<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
            <img src="@/assets/images/pages/500.png" alt="graphic-500" class="mx-auto mb-4">

            <div v-if="!offlinePlatform">
                <h1 class="sm:mx-0 mx-4 mb-4 sm:mb-12 text-5xl d-theme-heading-color">Oops!</h1>
                <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 text-dark">O Link/URL da loja informado não foi encontrado. Verifique o link ou nos chame no Suporte.</p>
            </div>

            <div v-else>
                <offline></offline>
            </div>

            <vs-button size="large" to="/">Voltar</vs-button>
        </div>
    </div>
</template>

<script>

import Offline from "@/views/offline-platform/Offline.vue";

export default {
    name: 'ErrorTenantInvalid',
    components: { Offline },
    computed: {
        offlinePlatform() {
          return this.$store.state.offlinePlatform;
        }
    },
    async mounted() {
        await this.$store.dispatch("updateWhatsappStatus");
        await this.$store.dispatch("updateMaintenanceStatus");
    }
}

</script>
